import { gql } from '__generated__';

export default gql(`
  query GetMailPreferences($participant_id: ID!, $token: String) {
    participantMailPreferences(participant_id: $participant_id, token: $token) {
      id
      email
      available_mail_permissions {
        id
        title
      }
      granted_mail_permissions {
        id
      }
    }
  }
`);
